import React from 'react';
import SolarSimulator from './components/SolarSimulator';
import './components/SolarSimulator.css';

function App() {
  return (
    <div className="App">
      <SolarSimulator />
    </div>
  );
}

export default App;